import { createContext as W, useState as f, useCallback as D, useRef as R, useContext as X, useEffect as P } from "react";
import { c as S } from "../../index-226b8ea6.js";
import { u as Y, a as Z, b as _, c as ee, d as se, e as te, f as ne, s as oe, g as ae, h as ie, i as le, j as re, k as ce, l as de } from "../../floating-ui.react-5e63cf1f.js";
import { getDropdownMaxHeight as ue } from "./Dropdown.helpers.es.js";
import { o as fe, f as pe, s as ge, a as me, b as ve } from "../../floating-ui.dom-55cf142e.js";
const Ie = W({
  activeIndex: null,
  getItemProps: () => ({}),
  open: !1,
  setActiveIndex: () => {
  },
  setHasFocusInside: () => {
  },
  setOpen: () => {
  }
}), Oe = (k = {}) => {
  const {
    disableInteractions: F = !1,
    disableParent: M = !1,
    forwardedRef: p,
    isOpen: g,
    maxHeight: H,
    setIsOpen: m
  } = k, [N, v] = f(!1), [A, T] = f(!1), [c, d] = f(null), o = g || N, s = D(
    (n) => {
      (m ?? v)(n);
    },
    [m, v]
  ), e = Y(), l = Z(), r = M ? null : _(), I = ee(), t = r != null, { floatingStyles: E, refs: h, context: a } = se({
    nodeId: l,
    open: o,
    onOpenChange: s,
    placement: t ? "right-start" : "bottom-start",
    middleware: [
      fe({ mainAxis: 0, alignmentAxis: t ? -4 : 0 }),
      pe(),
      ge(),
      me({
        apply({ elements: n, availableHeight: i }) {
          Object.assign(n.floating.style, {
            maxHeight: `${ue(i, H)}px`
          });
        },
        padding: 10
      })
    ],
    whileElementsMounted: ve
  }), x = R([]), b = R([]), j = X(Ie), L = te([h.setReference, I.ref, p]), $ = ne(a, {
    enabled: t,
    delay: { open: 75 },
    handleClose: oe({ blockPointerEvents: !0 })
  }), z = ae(a, {
    event: "mousedown",
    toggle: !t,
    ignoreMouse: t
  }), U = (n) => {
    const i = n.target.value;
    s(!!i);
  }, w = ie(a, { role: "listbox" }), C = le(a, { bubbles: !0 }), O = re(a, {
    listRef: x,
    activeIndex: c,
    nested: t,
    onNavigate: d
  }), q = ce(a, {
    listRef: b,
    onMatch: o ? d : void 0,
    activeIndex: c
  });
  let u;
  F ? u = [w, C, O] : u = [$, z, w, C, O, q];
  const { getReferenceProps: B, getFloatingProps: G, getItemProps: J } = de(u), K = () => s(!1), Q = () => s(!0), V = D(() => s(!o), [o]);
  return P(() => {
    if (!e)
      return;
    function n() {
      s(!1);
    }
    function i(y) {
      y.nodeId !== l && y.parentId === r && s(!1);
    }
    return e.events.on("click", n), e.events.on("menuopen", i), () => {
      e.events.off("click", n), e.events.off("menuopen", i);
    };
  }, [e, l, r]), P(() => {
    o && e && e.events.emit("menuopen", { parentId: r, nodeId: l });
  }, [e, o, l, r]), {
    activeIndex: c,
    buttonRef: L,
    context: a,
    elementsRef: x,
    floatingStyles: E,
    forwardedRef: p,
    getFloatingProps: G,
    getItemProps: J,
    getReferenceProps: B,
    hasFocusInside: A,
    isNested: t,
    isOpen: o,
    item: I,
    labelsRef: b,
    nodeId: l,
    onClose: K,
    onOpen: Q,
    onToggle: V,
    onChange: U,
    parent: j,
    parentId: r,
    refs: h,
    setActiveIndex: d,
    setHasFocusInside: T,
    tree: e
  };
}, [ye, De] = S(), [Re, Pe] = S({
  name: "DropdownStylesContext",
  errorMessage: `useDropdownStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Dropdown />" `
});
export {
  Ie as DropdownContext,
  ye as DropdownProvider,
  Re as DropdownStylesProvider,
  Oe as useDropdown,
  De as useDropdownContext,
  Pe as useDropdownStyle
};
//# sourceMappingURL=Dropdown.context.es.js.map
